module.exports = __webpack_public_path__ + "static/media/icon-card.6d3e8853.svg";